import React from "react";
//#region types
import { ActionLinksGroupProps } from "models/propTypes/commonPropTypes";
import { GridSize } from "@mui/system";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { ActionLinksGroupButton } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const ActionLinksGroup: React.FC<ActionLinksGroupProps> = ({ links, columns }) => {
  const visibleButtons = links.filter((x) => !x.hidden);

  const getColumnCount = (columnWidth: GridSize) => (typeof columnWidth == "number" ? 12 / columnWidth : 1);
  const getColumnMargin = (columnCount: number) => {
    if (columnCount === 1) return 0;

    const margin = ((columnCount - 1) * -1) / columnCount;
    const roundedMargin = parseFloat(margin.toFixed(2));
    return roundedMargin;
  };

  const columnWidthCounts = columns ?? { xs: 12, sm: 6, md: 4, lg: 6, xl: 6 };
  const columnCounts = {
    xs: getColumnCount(columnWidthCounts.xs),
    sm: getColumnCount(columnWidthCounts.sm),
    md: getColumnCount(columnWidthCounts.md),
    lg: getColumnCount(columnWidthCounts.lg),
    xl: getColumnCount(columnWidthCounts.xl),
  };
  const margins = {
    xs: getColumnMargin(columnCounts.xs),
    sm: getColumnMargin(columnCounts.sm),
    md: getColumnMargin(columnCounts.md),
    lg: getColumnMargin(columnCounts.lg),
    xl: getColumnMargin(columnCounts.xl),
  };

  return (
    <Grid container columnGap={1} className={cssExports.actionLinkButtonGroup}>
      {visibleButtons.map((button, index) => (
        <Grid key={index} item {...columnWidthCounts} marginRight={margins}>
          <ActionLinksGroupButton button={button} index={index} />
        </Grid>
      ))}
    </Grid>
  );
};

export default ActionLinksGroup;
